// src/pages/public/Portfolio.js
import React from "react";
import { Helmet } from 'react-helmet-async';
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { PROJECTS, COMPANY } from "../../utils/constants";

export default function Portfolio() {
  return (
    <div style={{ paddingTop: "var(--header-h)" }}>
      <Helmet>
        <title>Our Portfolio - Aimble I.T. Solutions</title>
        <meta name="description" content="View the portfolio of Aimble I.T. Solutions. See our recent custom websites, web apps, and digital solutions built for businesses in Sorsogon and beyond." />
        <link rel="canonical" href="https://www.aimbletech.com/portfolio" />
      </Helmet>
      <section className="section-sm" style={{ textAlign: "center" }}>
        <div className="container">
          <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }}>
            <div className="section-label" style={{ justifyContent: "center" }}>Portfolio</div>
            <h1 className="heading-1" style={{ marginBottom: 16 }}>Projects we're proud of</h1>
            <p className="body-lg text-muted" style={{ maxWidth: 480, margin: "0 auto" }}>
              From school websites to commerce platforms — here's what we've built.
            </p>
          </motion.div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: 28 }}>
            {PROJECTS.map((project, i) => (
              <motion.div key={project.id} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }}>
                <div className="card card-glow" style={{ display: "flex", flexDirection: "column", height: "100%" }}>
                  {/* Preview image */}
                  <div style={{ height: 200, background: "var(--navy-mid)", borderRadius: 8, marginBottom: 20, overflow: "hidden", position: "relative", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    {project.image ? (
                      <img src={project.image} alt={project.title} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                    ) : (
                      <>
                        <span style={{ fontSize: "4rem", opacity: 0.15 }}>🌐</span>
                        <div style={{ position: "absolute", inset: 0, background: "linear-gradient(135deg, rgba(0,201,167,0.05), rgba(59,130,246,0.05))" }} />
                      </>
                    )}
                    {project.link !== "#" && (
                      <a
                        href={project.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ position: "absolute", top: 12, right: 12 }}
                      >
                        <span className="badge badge-accent">Live Site ↗</span>
                      </a>
                    )}
                  </div>

                  <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 12 }}>
                    {project.tags.map(t => <span key={t} className="badge badge-blue">{t}</span>)}
                    <span className="badge" style={{ background: "var(--surface-2)", color: "var(--text-dim)" }}>{project.year}</span>
                  </div>
                  <h3 style={{ fontSize: "1.125rem", fontWeight: 700, fontFamily: "var(--font-head)", marginBottom: 8 }}>{project.title}</h3>
                  <p style={{ fontSize: "0.875rem", color: "var(--text-muted)", lineHeight: 1.6, flex: 1, marginBottom: 20 }}>{project.description}</p>

                  {project.link !== "#" ? (
                    <a href={project.link} target="_blank" rel="noopener noreferrer" className="btn btn-secondary btn-sm" style={{ alignSelf: "flex-start" }}>
                      Visit Site →
                    </a>
                  ) : (
                    <span style={{ fontSize: "0.8125rem", color: "var(--text-dim)" }}>Private project</span>
                  )}
                </div>
              </motion.div>
            ))}
          </div>

          {/* CTA */}
          <motion.div initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} style={{ marginTop: 64, textAlign: "center" }}>
            <p className="body-lg text-muted" style={{ marginBottom: 20 }}>Want to be our next success story?</p>
            <div style={{ display: "flex", gap: 16, justifyContent: "center", flexWrap: "wrap" }}>
              <Link to="/packages" className="btn btn-primary btn-lg">Start a Project</Link>
              <a href={COMPANY.facebook} target="_blank" rel="noopener noreferrer" className="btn btn-secondary btn-lg">Message Us on Facebook</a>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
